import { render, staticRenderFns } from "./CopyToVariantDialog.vue?vue&type=template&id=bb40d5c8&scoped=true"
import script from "./CopyToVariantDialog.ts?vue&type=script&lang=ts&external"
export * from "./CopyToVariantDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CopyToVariantDialog.scss?vue&type=style&index=0&id=bb40d5c8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb40d5c8",
  null
  
)

export default component.exports